<template>
  <footer role="contentinfo" class="footer text-center overflow-hidden position-relative">
    <div class="site-info">
      <div class="container">
        <b-row>
          <b-col class="col-12">
            <b-row class="top-footer">
              <b-col class="col-12 col-sm-6 col-md-6 image">
                <img class="img-fluid float-md-left footer-logo" src="/leadsio-logo-white-alt.svg" alt="Boilerguide Installer Dashboard">
              </b-col>
              <b-col class="col-12 col-sm-6 col-md-6 gas-safe">
                <div v-if="showGasSafe !== false" class="gas-safe-wrap float-md-right">
                  <div class="gas-safe-inner d-flex align-items-center">
                    <div class="image float-left">
                      <img alt="Gas Safe Register" src="/gas-safe-register.png">
                    </div>
                    <div class="float-left font-weight-500 pl-3">
                      <div class="copy">
                        <span>{{ $t('Stay Safe.') }}</span>
                      </div>
                      <div class="copy">
                        {{ $t('Always use a Gas Safe registered engineer') }}
                      </div>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row class="py-2">
              <b-col class="text-md-left small col-12 col-md-6 d-flex flex-column">
                <p class="mb-0">
                  {{ $t('Leads.io Ltd. Registered in England & Wales number 6873930. E&OE') }}
                </p>
                <p class="mb-0">
                  {{ $t('Gas Safe Register is a registered trade mark of HSE and is used under license.') }}
                </p>
              </b-col>
              <b-col class="col-12 col-md-6">
                <b-navbar-nav class="navbar-collapse d-flex flex-row justify-content-center justify-content-md-end">
                  <b-nav-text class="d-md-inline-flex menu-item">
                    <a :title="$t('Cookies')" href="https://www.boilerguide.co.uk/trade/cookies/" class="nav-link">{{ $t('Cookies') }}</a>
                  </b-nav-text>
                  <b-nav-text class="d-md-inline-flex menu-item">
                    <a :title="$t('Privacy Policy')" href="https://www.boilerguide.co.uk/trade/privacy/" class="nav-link">{{ $t('Privacy Policy') }}</a>
                  </b-nav-text>
                  <b-nav-text class="d-md-inline-flex menu-item">
                    <a :title="$t('Terms &amp; Conditions')" href="https://www.boilerguide.co.uk/trade/terms-and-conditions/" class="nav-link">
                      {{ $t('Terms &amp; Conditions') }}
                    </a>
                  </b-nav-text>
                  <b-nav-text class="d-md-inline-flex menu-item">
                    <a class="nav-link">{{ $t('Copyright Leads.io', { currentYear: new Date().getFullYear() }) }}</a>
                  </b-nav-text>
                </b-navbar-nav>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  props: ['showGasSafe']
}
</script>

<style scoped lang="scss">
.footer {
  font-size: $font-size-14;
  z-index: 1;
  padding: 20px 0 0;
  background: linear-gradient(180deg, $ellipse-gradient-first 0, $ellipse-gradient-secondary 100%) no-repeat;
  clip-path: ellipse(115% 90% at 50% 92%);
  color: $white;
  min-height: 230px;

  .inline-link {
    color: $white;
  }

  @include media-breakpoint-down(sm) {
    clip-path: ellipse(150% 90% at 50% 92%);
  }

  li .nav-link {
    color: white;
    font-size: $font-size-13;
    margin-right: 15px;
    text-decoration: none;
  }

  .navbar-nav > li:after {
    content: none;
  }

  .footer-logo {
    max-width: 250px;
  }
}

.top-footer {
  margin: 55px 0 20px;
  @include media-breakpoint-down(sm) {
    margin-top: 20px
  }
}

.gas-safe-wrap {
  line-height: 1.1;
  max-width: 225px;
  @include media-breakpoint-down(md) {
    margin: 10px auto 5px;
  }
  .copy {
    color: $gas-safe-yellow;
    text-align: left;
  }

  .image img {
    max-width: 60px;
  }
}

</style>
